/* global FB, $ */

'use strict';

function facebookShareInit(EVENTS) {
	var PubSub = require('pubsub-js');

	(function(d, s, id) {
	    var js, fjs = d.getElementsByTagName(s)[0];
	    if (d.getElementById(id)) {return;}
	    js = d.createElement(s); js.id = id;
	    js.src = '//connect.facebook.net/en_GB/sdk.js';
	    fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

	window.fbAsyncInit = function() {
		FB.init({
			appId      : '84697719333', // nike APP id
			version    : 'v2.5'
		});

		var shareButton = document.getElementById('button-share'),
			$sharePage = $('#share'),
			$termsInput = $sharePage.find('#terms');

		if ( shareButton !== 'undefined' && shareButton !== null) {
			shareButton.onclick = function() {
				PubSub.publish(EVENTS.FACEBOOK_TRACKING, this);
				if (!$termsInput.prop('checked')){ return; }

				var image = $sharePage.find('.img-sharing').find('img'),
					imageUrl = image.attr('src');
			  	FB.ui({
					display: 'popup',
					method: 'share',
					href: imageUrl
				}, function(response){});
		    };
		}
	};
}

module.exports = facebookShareInit;
